import api from 'api'

import { validateApiResponse } from 'utils/validateApiResponse'

import { getRelatedDataAccessRequestsResponseSchema } from './schemas'
import type { GetRelatedDataAccessRequestsResponse } from './types'

export const getRelatedDataAccessRequests = async (groupId: string): Promise<GetRelatedDataAccessRequestsResponse> => {
  const { data } = await api.get<GetRelatedDataAccessRequestsResponse>(
    `/data-access-requests/verification/groups/${encodeURIComponent(groupId)}/requests`
  )

  return validateApiResponse(getRelatedDataAccessRequestsResponseSchema, data)
}
